import { render, staticRenderFns } from "./ButtonInspectResult.vue?vue&type=template&id=1064902a&"
import script from "./ButtonInspectResult.vue?vue&type=script&lang=ts&"
export * from "./ButtonInspectResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports